<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>التسجيل في قطوف</h2>
            <p>الخطوة الأولى شروط التسجيل</p>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="row align-items-center">




            <div class="">
                <div class="content left-content">
                    <h4>شروط التسجيل:</h4>
                    <!--<p>طلاب المشروع: ويقصد بهم الطلاب من الصف الخامس حتى العاشر والذين هم من طلاب أحد المدارس الآتية:</p>-->
                    <br />
                    <div class="row">

                      

                    </div>
                </div>
            </div>
            <!--<h6>مع توفر الشروط الآتية للتسجيل:</h6>-->
            <ul>
                <li>	أن يكون من خريجي المشروع فقط.</li>
                <li>	التواصل المستمر والمواظبة الحضورية في الحلقات القرآنية طوال العام.</li>
                <li>	المشاركة الفعالة في تلاوة وحفظ القرآن الكريم مع إتقانه عن طريق الاختبارات الكتابية والشفوية.</li>
            </ul>
           

            <button type="submit" class="default-btn" (click)="onClickBT()">أوافق على الشروط</button>


        </div>
    </div>
</div>
